import { Timestamp } from "firebase/firestore";
import { DateTime } from "luxon";

export const luxonDateToTimestamp = (date: luxon.DateTime): Timestamp => {
    return Timestamp.fromDate(date.toJSDate());
}

export const TimestampToLuxonDate = (timestamp: Timestamp): luxon.DateTime => {
    return DateTime.fromJSDate(timestamp?.toDate());
}